import * as Sentry from '@sentry/react';
import './networks.scss';
import type { INetworkModel, IHandleNetworkChange } from '../../interfaces/network.model';

export function Network({ network, isActive, onNetworkClick }: { network: INetworkModel; isActive: boolean; onNetworkClick: IHandleNetworkChange }) {
  return (
    <Sentry.ErrorBoundary>
      <button type="button" className={`network-badge ${isActive ? ' active' : ''}`} onClick={onNetworkClick}>
        <img alt={network.name} className="skeleton icon" src={network.img} />
        <span className="network-badge__text">{` ${network.name}`}</span>
      </button>
    </Sentry.ErrorBoundary>
  );
}
